import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthResponse, LoginRequest } from '../../../core/models/auth.model';
import { HttpService } from '../../../core/services/http.service';

/**
 * LoginService
 *
 * Credential authentication used in non-PPN environments (local / dev).
 */
@Injectable({ providedIn: 'root' })
export class LoginService extends HttpService {
  /**
   * Authenticates a user with credentials.
   *
   * API: `POST /users/authenticate`
   *
   * @param credentials Login id and password.
   * @returns Observable of the token and user profile (with role permissions).
   */
  authenticate(credentials: LoginRequest): Observable<AuthResponse> {
    return this.postData<AuthResponse>('/users/authenticate', credentials);
  }
}
